import { Button } from "@/components/ui/button";
import { Copy } from "lucide-react";
import { toast } from "sonner";

export function CodeBlock({ code, language = "python" }: { code: string; language?: string }) {
  return (
    <div className="relative group min-w-0">
      <pre className="bg-muted text-foreground p-4 rounded-lg overflow-x-auto text-sm font-mono border border-border">
        <code>{code}</code>
      </pre>
      <Button
        size="sm"
        variant="ghost"
        className="absolute top-2 right-2 h-8 w-8 p-0 opacity-0 group-hover:opacity-100 transition-opacity bg-accent hover:bg-accent/80 text-accent-foreground"
        onClick={() => {
          navigator.clipboard.writeText(code);
          toast.success("Copied to clipboard");
        }}
      >
        <Copy className="h-4 w-4" />
      </Button>
    </div>
  );
}
